import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
	{
		_id: uuid(),
		categoryName: "BBL",
	},
	{
		_id: uuid(),
		categoryName: "CPL T20",
	},
	{
		_id: uuid(),
		categoryName: "The Hundred",
	},
	{
		_id: uuid(),
		categoryName: "ICC",
	},
	{
		_id: uuid(),
		categoryName: "T10 League",
	},
];
